import Base64 from '../utils/base64'

const listOfValueConversion = (arr: any) => {
  if (arr.length === 0) return []
  return arr.map((v: any) => ({
    value: v,
    label: v,
  }))
}

export const conversionData = (data: any, isCustom: boolean) => {
  if (!data && data.length === 0) {
    return []
  }

  const fields: any = []
  data.forEach((item: any) => {
    const params: any = {}
    params.isB3User = true
    params.custom = isCustom
    params.name = `${Base64.encode(item.fieldName)}`
    params.label = item.fieldName
    params.val = item?.defaultValue || ''
    params.default = item?.defaultValue || ''
    params.required = item.isRequired
    params.id = `${item.fieldName}`
    params.visibleToEnduser = item.visibleToEnduser
    if (item.fieldType === 0) {
      params.fieldType = 'text'
      params.type = "string"
      params.max = item.maximumLength
      params.maxLength = item.maximumLength
    } else if (item.fieldType === 1) {
      params.fieldType = 'multiline'
      params.type = "string"
      params.options = { rows: item?.numberOfRows + '' || '5' }
    } else if (item.fieldType === 2) {
      params.fieldType = 'text'
      params.type = "integer"
      params.max = item.maximumValue && +item.maximumValue
      params.maxLength = item.maximumValue && +item.maximumValue
    } else if (item.fieldType === 3) {
      params.fieldType = 'dropdown'
      params.type = "array"
      params.options = {
        helperLabel: 'Please Select',
        items: item?.listOfValue ? listOfValueConversion(item.listOfValue) : []
      }
    }
    fields.push(params)
  })
  return fields
}

export const decodeExtraFieldsKeys = (Fields: any) => {
  const newobj: any = {}
  const keys: any = Object.keys(Fields) || []

  keys.length && keys.forEach((item: any) => {
    const newKey = Base64.decode(item)
    newobj[newKey] = Fields[item]
  })

  return newobj
} 